export default "void main()    {\n\n    gl_Position = vec4(position, 1.0);\n\n}";